import { useCallback, useEffect, useRef, useState } from 'react';
import { Box } from '@material-ui/core';
import { useIntl } from 'umi';
import { useLocation, history, useDispatch } from 'umi';
import qs from 'qs';
import dayjs from 'dayjs';
import webStorage from '@/utils/storageManager';
import CardListML from '@/components/CardListML';
import ResultList from './components/result_list/ResultList';
import SearchGroup from './components/search_group/SearchGroup';

export default (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const location = useLocation();
  const searchRef = useRef();
  const [isSearch, setIsSearch] = useState(false);
  const { query, pathname } = location;
  const userAuths = webStorage.get('USER')?.authorities;
  // 结构到所有查询条件，包括分页条件
  const {
    title,
    status,
    type,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };
  //获取优惠券列表
  const fetchCouponList = useCallback(() => {
    const values = {
      pageNum,
      pageSize,
      title,
      status,
      refreshTime,
      type,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'cpList/getCpList',
      payload: {
        values: {
          ...values,
          rejectType: '',
        },
      },
    });
  }, [dispatch, pageNum, pageSize, status, title, type, refreshTime]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);

  const cardList = [
    {
      cardTitle: formatMessage({ id: 'coupon.mgt.n01.lbl01' }),
      cardDesc: [
        formatMessage({ id: 'coupon.mgt.n01.txt01' }),
        formatMessage({ id: 'coupon.mgt.n01.txt02' }),
      ],
      imgUrl: require('@/assets/img/shoes_three.jpg'),
      href: '/coupon/coupon_list/cash',
      type: '2',
      disabled: !userAuths.includes('MENU_COUPON_CASH'),
    },
    {
      cardTitle: '免票券',
      cardDesc: ['用于针对指定剧目', '指定场次免票'],
      imgUrl: require('@/assets/img/shoes_two.jpg'),
      href: '/coupon/coupon_list/free_pass',
      type: '9',
      disabled: !userAuths.includes('MENU_COUPON_FREE_PASS'),
    },
    {
      cardTitle: '兑换券',
      cardDesc: ['例：用于兑换指定礼品', '吸引顾客消费'],
      imgUrl: require('@/assets/img/shoes_one.jpg'),
      href: '/coupon/coupon_list/exchange',
      type: '4',
      oid: 'btn_coupon_center_coupon_management_list_create_exchange',
      disabled: !userAuths.includes('MENU_COUPON_EXCHANGE'),
    },
    {
      cardTitle: '礼品券',
      cardDesc: ['用于发放邮寄礼品'],
      imgUrl: require('@/assets/img/shoes_ten.jpg'),
      href: '/coupon/coupon_list/gift',
      type: '10',
      oid: 'btn_coupon_center_coupon_management_list_create_gift',
      disabled: !userAuths.includes('BTN_COUPON_GIFT_VOUCHER'),
    },
    {
      cardTitle: '三方券',
      cardDesc: ['用于关联第三方礼品券'],
      imgUrl: require('@/assets/img/shoes_eleven.png'),
      href: '/coupon/coupon_list/third',
      type: '11',
      oid: 'btn_coupon_center_coupon_management_list_create_third',
      disabled: !userAuths.includes('MENU_COUPON_EXTERNAL_COUPON'),
    },
    {
      cardTitle: '三方礼品券',
      cardDesc: ['用于上传三方礼品券CDK'],
      imgUrl: require('@/assets/img/shoes_eleven.png'),
      href: '/coupon/coupon_list/third_gift',
      type: '8',
      oid: 'btn_coupon_center_coupon_management_list_create_third_gift',
      disabled: !userAuths.includes('MENU_COUPON_THIRD_GIFT_COUPON'),
    },
  ];

  const handleClick = (data) => {
    data.href &&
      props.history.push({
        pathname: data.href,
        query: { opt: 'add', type: data.type, sourceOid: data.oid },
      });
  };
  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_coupon_center_coupon_management_list',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <CardListML cardList={cardList} handleClick={handleClick} />
      <SearchGroup
        searchRef={searchRef}
        query={query}
        handleSearch={(par) => handleSearch(par)}
        restClick={handleRestClick}
      />
      <ResultList
        handlePageChange={handlePageChange}
        pageData={{ pageNum, pageSize }}
      />
    </Box>
  );
};
